<template>
<div>
  <span v-if="value>0" :class="computedClass"> {{value}} </span>
  <span v-else :class="computedClass"> {{ $t('models.project.unsynced_leads_count_success') }} </span>
</div>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    computedClass(){
      let classes = ["sensual-badge"]
      if (this.value > 0) {
        classes.push('yellow')
      } else {
        classes.push('green')
      }
      return classes
    },
    value(){
      return eval('this.item.' + this.column.name)
    }
  }
}
</script>
<style lang="scss" scoped>
.number{
  color: #d00019;
  font-weight: 600;
}
.icon{
  color: #88ba47;
}
</style>



// WEBPACK FOOTER //
// CollectionValueUnsyncedCount.vue?8e222f72